import { Lightning } from '@lightningjs/sdk'
import { getColor, grey300, grey50, transparent } from '../../../constants/colors'
import { UniNeueBold, UniNeueRegular } from '../../../constants/fonts'
import { TvTabModel } from '../../../types/flo-experience'
import SpeechComp from '../../speechComp/speechComp'

const BOLD_PADDING = 3
export default class TvTab extends SpeechComp {
  private _data: TvTabModel
  private _padding = 24
  private _isSelected = false
  private _tabIndex = 0
  private _itemIndex: number
  private _totalItems: number

  static _template() {
    return {
      h: 82,
      rect: true,
      color: transparent,
      collision: true,
      Label: {
        x: (w) => w / 2,
        y: (h) => h / 2,
        mount: 0.5,
        text: {
          text: '',
          textColor: getColor(grey300),
          fontSize: 32,
          fontFace: UniNeueRegular,
        },
      },
      Indicator: {
        h: 6,
        y: 68,
        rect: true,
        color: getColor(grey300),
        visible: false,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: 2,
        },
      },
    }
  }

  get label() {
    return this.tag('Label')
  }

  get speechText() {
    return this.label?.text?.text + ' Tab ' + (this.itemIndex + 1) + ' of ' + this._totalItems
  }

  get indicator() {
    return this.tag('Indicator')
  }

  get isSelected() {
    return this._isSelected
  }

  set isSelected(v) {
    this._isSelected = v
    this.indicator.visible = v
  }

  set data(v: TvTabModel) {
    this._data = v
    this.label.patch({ text: { text: v?.title?.text ?? '' } })
  }

  get data() {
    return this._data
  }

  set tabIndex(v) {
    this._tabIndex = v
  }

  get tabIndex() {
    return this._tabIndex
  }

  get itemIndex() {
    return this._itemIndex
  }

  set itemIndex(v: number) {
    this._itemIndex = v
  }

  get totalItems() {
    return this._totalItems
  }

  set totalItems(v: number) {
    this._totalItems = v
  }

  _init() {
    this.label.on('txLoaded', () => {
      if (this.w < this.label.renderWidth + this._padding * 2) {
        const width = this.label.renderWidth + this._padding * 2 + BOLD_PADDING
        this.w = width
        this.indicator.w = width
      }
    })
  }

  _focus() {
    this.label.patch({
      text: {
        textColor: getColor(grey50),
        fontFace: UniNeueBold,
      },
    })

    this.indicator.patch({
      color: getColor(grey50),
    })
    this.speak()
  }

  _unfocus() {
    this.label.patch({
      text: {
        textColor: getColor(grey300),
        fontFace: UniNeueRegular,
      },
    })

    this.indicator.patch({
      color: getColor(grey300),
    })
  }

  toggleTab(toggle: boolean) {
    if (toggle) {
      this.fireAncestors('$onTabChange', this.data?.action?.url)
    }

    this.indicator.visible = toggle
    this._isSelected = toggle
  }

  setActive() {
    this.indicator.visible = true
    this._isSelected = true
  }

  _handleHover() {
    this.fireAncestors('$updateFocusByHover')
    this._focus()
  }

  _handleUnhover() {
    this._unfocus()
  }

  _handleClick() {
    this.fireAncestors('$updateFocusByHover', this)
  }
}
